"use client";

import AppBanner from "@/components/AppBanner";
import BenefitCard from "@/components/BenefitCard";
import BlogCard from "@/components/BlogCard";
import BrandCard from "@/components/featured/common/cards/BrandCard";
import CampaignCard from "@/components/CampaignCard";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import PopularFlightTicketCard from "@/components/PopularFlightTicketCard";
import PopularListItemCard from "@/components/PopularListItemCard";
import PopularLocationCard from "@/components/PopularLocationCard";
import RegisterBanner from "@/components/RegisterBanner";

export const flightHomeComponentRegistry = {
  OpportunitiesCardWrapper,
  // OpportunitiesCard,
  CampaignCard,
  PopularFlightTicketCard,
  PopularLocationCard,
  PopularListItemCard,
  BenefitCard,
  BrandCard,
  BlogCard,
  AppBanner,
  RegisterBanner,
};

export const flightHomeItemPropMapping = {
  OpportunitiesCardWrapper: "item",
  // OpportunitiesCard: "item",
  CampaignCard: "item",
  PopularFlightTicketCard: "item",
  PopularLocationCard: "item",
  PopularListItemCard: "item",
  BenefitCard: "item",
  BrandCard: "brand",
  BlogCard: "post",
};
